const SNIPPET_MAX = 120

export function getReplyPreviewSnippet(text, attachmentCount = 0) {
  const base = String(text ?? '')
    .replace(/\s+/g, ' ')
    .trim()
  const clipped = base.length > SNIPPET_MAX ? `${base.slice(0, SNIPPET_MAX - 1)}…` : base
  const n = Number(attachmentCount) || 0
  if (n > 0) {
    const label = n === 1 ? '1 attachment' : `${n} attachments`
    return clipped ? `${clipped} · ${label}` : label
  }
  return clipped
}
